export default "__VITE_ASSET__DkP0P1RB__"